import { render, staticRenderFns } from "./r-item-group-dialog.vue?vue&type=template&id=f5343974&scoped=true"
import script from "./r-item-group-dialog.vue?vue&type=script&lang=js"
export * from "./r-item-group-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-item-group-dialog.vue?vue&type=style&index=0&id=f5343974&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5343974",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f5343974')) {
      api.createRecord('f5343974', component.options)
    } else {
      api.reload('f5343974', component.options)
    }
    module.hot.accept("./r-item-group-dialog.vue?vue&type=template&id=f5343974&scoped=true", function () {
      api.rerender('f5343974', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/item-group/r-item-group-dialog.vue"
export default component.exports